// extracted by mini-css-extract-plugin
export var active = "_2w-7";
export var backButton = "_2w-6";
export var clone = "_2w-c";
export var collapseBar = "_2w-h";
export var collapseMode = "_2w-j";
export var dragHandle = "_2w-a";
export var dropdownIcon = "_2w-e";
export var hidden = "_2w-p";
export var iconContainer = "_2w-m";
export var iconSwapper = "_2w-o";
export var navItem = "_2w-4";
export var navItemIcon = "_2w-d";
export var navProfile = "_2w-5";
export var notificationCountBadge = "_2w-g";
export var notificationDot = "_2w-n";
export var optionsContainer = "_2w-f";
export var primaryNav = "_2w-0";
export var primaryTab = "_2w-k";
export var secondaryNav = "_2w-1";
export var selected = "_2w-l";
export var settingsNav = "_2w-2";
export var settingsNavItems = "_2w-3";
export var show = "_2w-b";
export var sideNav = "_2w-i";
export var teamItem = "_2w-8";
export var userProfileItem = "_2w-9";